import { Component, OnInit, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ReguleringService } from './regulering.service';
import { Observable, Subject, Subscription, combineLatest } from 'rxjs';
import { ProductService } from '../product/product.service';
import { map, startWith } from 'rxjs/operators';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { ReguleringPopupComponent } from './regulering-popup/regulering-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { ApplyChangesDetailComponent } from './applyChangesDetail-popup/applyChangesDetail-popup.component';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-regulering',
  templateUrl: './regulering.component.html',
  styleUrls: ['./regulering.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReguleringComponent implements OnInit {
  product$;
  productFilter$ = new Subject()
  filteredProduct$;
  onShowUnit: EventEmitter<ActionButtonEvent>;
  onShowUnitApplyChanges: EventEmitter<ActionButtonEvent>;

  onShowUnitSubscription: Subscription;
  onShowUnitApplyChangesSubscription: Subscription;

  filterString = "";
  filteredStatesSub: Subscription;
  timer;
  searchResultReceived = false;

  data$: Observable<{}>;
  getApplyChanges$: Observable<{}>;
  inputDate;
  toTime;
  timeSelected = 'CUSTOM'
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'productNameFrom',
      name: 'From',
    },
    {
      columnId: 'productNameTo',
      name: 'To'
    },
    {
      columnId: 'timestamp',
      name: 'CreatedAt',
    },
    {
      columnId: 'performAt',
      name: 'Perform At',
    },
    {
      columnId: 'status',
      name: 'Status',
    },
    {
      columnId: 'pending',
      name: 'Total',
    },
    {
      columnId: 'completed',
      name: 'Completed',
    }]

  columnSettingsApplyChanges: ColumnSetting[] = [

    {
      columnId: 'timestamp',
      name: 'Created At',
    },
    {
      columnId: 'status',
      name: 'Status',
    },
    {
      columnId: 'performAt',
      name: 'Perform At',
    },
    {
      columnId: 'completed',
      name: 'Completed',
    }]
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  rowActionButtonsForApplyChanges: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];

  user: User;

  reguleringData = {
    productIdFrom: "",
    productNameFrom: "",
    productIdTo: "",
    productNameTo: "",
    performedBy: "",
    performAt: moment().unix(),
    status: "scheduled",
    worker: "productRegulering",
    options: {}
  }

  applyChangesData = {
    performedBy: "",
    performAt: moment().unix(),
    status: "scheduled",
    worker: "applyChanges"
    }






  constructor(private auth: AuthService, private dialog: MatDialog, private productService: ProductService, private reguleringService: ReguleringService) {
    this.productService.getProducts();
    this.data$ = this.reguleringService.getRegulerings();

    this.getApplyChanges$ = this.reguleringService.getApplyChanges();

    this.auth.user$.subscribe(user => this.user = user)

    this.onShowUnit = new EventEmitter<ActionButtonEvent>();
    this.onShowUnitApplyChanges = new EventEmitter<ActionButtonEvent>();

    this.rowActionButtons = [
      { icon: 'info_outline', tooltip: 'Show unit', eventEmitter: this.onShowUnit }
    ]
    this.rowActionButtonsForApplyChanges = [
      { icon: 'info_outline', tooltip: 'Show unit', eventEmitter: this.onShowUnitApplyChanges }
    ]


    this.onShowUnitSubscription = this.onShowUnit.subscribe(event => {
      // alert('Not implemented');
      let data = event.eventData
      if (data) {
        this.dialog.open(ReguleringPopupComponent, {
          disableClose: true,
          width: '1200px',
          data: data
        });
      }
    });

    this.onShowUnitApplyChangesSubscription = this.onShowUnitApplyChanges.subscribe(event => {
      // alert('Not implemented');
      let data = event.eventData
      if (data) {
        this.dialog.open(ApplyChangesDetailComponent, {
          disableClose: true,
          width: '1000px',
          data: data
        });
      }
    });
  }

  ngOnInit() {

    this.product$ = this.productService.data;


    this.filteredProduct$ = combineLatest(
      this.product$, this.productFilter$.pipe(startWith(""))).pipe(map(([data, filter]) => {
        if (this.filterString != filter) {
          this.searchResultReceived = false;
        }
        this.filterString = filter as string;

        return ((data as Array<{}>).filter(option => option['name'].toLowerCase().includes(filter)))

      }))

    this.filteredStatesSub = this.filteredProduct$.subscribe(data => {
      if (this.filterString.length > 2 && !this.searchResultReceived) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.productService.getProductByNameAndPartNumber(this.filterString);
          this.searchResultReceived = true;


        }, 1000)
      }
    })
  }

  applyProductFilter(filterValue: string) {
    this.productFilter$.next(filterValue.toLowerCase());
  }

  setProductFrom(obj) {
    console.log("from", obj)
    if (obj === '') {
      this.reguleringData.productIdFrom = "";
      this.reguleringData.productNameFrom = ""
      return
    }
    this.reguleringData.productIdFrom = obj.id;
    this.reguleringData.productNameFrom = obj.name
  }


  setProductTo(obj) {
    console.log("to", obj)

    if (obj === '') {
      this.reguleringData.productIdTo = "";
      this.reguleringData.productNameTo = ""
      return
    }
    this.reguleringData.productIdTo = obj.id;
    this.reguleringData.productNameTo = obj.name
  }

  onSubmit(form) {
    if (this.toTime){
      this.reguleringData.performAt = moment(this.inputDate).set('hour', this.toTime.split(':')[0]).set('minute', this.toTime.split(':')[1]).tz('Europe/Oslo').unix();
      
    }
    this.reguleringData.performedBy = this.user.email;

    let options = this.reguleringData;
    console.log(options)
     this.reguleringService.requestRegulering({...this.reguleringData,options})

  }



  applychangesforall() {
    // applychangesforall
    let options = this.applyChangesData;
    if (this.toTime){
    this.applyChangesData.performAt = moment(this.inputDate).set('hour', this.toTime.split(':')[0]).set('minute', this.toTime.split(':')[1]).tz('Europe/Oslo').unix();
    }
    this.applyChangesData.performedBy = this.user.email;

    this.reguleringService.applyChangesForAll({...this.applyChangesData,options})

  }

  setToTime() {
    this.toTime = document.getElementById("startTime")['value']
    // console.log(startTime['value'].split(':')[0])
    // this.inputDate =  moment(this.inputDate).set('hour',startTime['value'].split(':')[0]).set('minute',startTime['value'].split(':')[1]).toDate()
    //  console.log( this.inputDateTo)
  }



  setCustomRange(event: MatDatepickerInputEvent<Date>, picker: 'start' | 'end') {
    
    if (picker === 'start')
      this.inputDate = moment(event.value).startOf('day').toDate();
  }

  ngOnDestroy() {
    this.onShowUnitApplyChangesSubscription.unsubscribe()
    this.onShowUnitSubscription.unsubscribe()
  }
}
